module.exports = __webpack_public_path__ + "img/total-costs-icon.127392a5.svg";